<button type="button" class="camera-icon-btn" [class]="variant" [attr.aria-label]="ariaLabel" (click)="onClick($event)">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="camera-svg">
        <path
            d="M22 6H18.5L17 4H7L5.5 6H2C0.9 6 0 6.9 0 8V20C0 21.1 0.9 22 2 22H22C23.1 22 24 21.1 24 20V8C24 6.9 23.1 6 22 6Z"
            fill="currentColor" />
        <circle cx="12" cy="14" r="4" fill="currentColor" class="center-circle" />
        <circle cx="12" cy="14" r="5.5" stroke="currentColor" stroke-width="1.5" />
    </svg>
</button>